import { Search } from "lucide-react";

function SearchBar({ value, onChange, placeholder = "Cari...", className = "" }) {
  return (
    <div className={"relative " + className}>
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" aria-hidden="true" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="input pl-10"
      />
    </div>
  );
}

export default SearchBar;
